module.exports = __webpack_public_path__ + "img/osm_madmanspool1.dce560d.png";